import {
  DatePicker,
  Icon,
  CalendarIcon,
  ChevronIcon,
  Cleanstate,
  CleanstateLabels,
  CleanstateTitle,
  CleanstateLabel,
  Wrapper,
  Section,
  SectionGroup,
  Label,
  Value
} from './styles'

export { HostStyles } from './styles'

DatePicker.Icon = Icon
DatePicker.CalendarIcon = CalendarIcon
DatePicker.ChevronIcon = ChevronIcon
DatePicker.Cleanstate = Cleanstate
DatePicker.CleanstateLabels = CleanstateLabels
DatePicker.CleanstateTitle = CleanstateTitle
DatePicker.CleanstateLabel = CleanstateLabel
DatePicker.Wrapper = Wrapper
DatePicker.Section = Section
DatePicker.SectionGroup = SectionGroup
DatePicker.Label = Label
DatePicker.Value = Value

export default DatePicker
